@file:kotlin.js.JsExport
package com.narbase.letsgo.web.dto.passengerlocation
import com.narbase.letsgo.dto.core.KmmLong

import com.narbase.letsgo.dto.core.DateTimeDto

class PassengerLocationDto (
    val id: KmmLong?,
    val createdOn: DateTimeDto?,
    val passengerId: KmmLong,
    var lat: Double,
    var lng: Double
)